<div class="component-container container">
	<div class="tab-content">
		<div class="clearfix">
			<div class="font-mont-semi-bold form-step-number">2</div>
			<div class="form-step-title" *ngIf="owners.length <= 1">
				<h1 class="font-mont-semi-bold">Owner Information</h1>
			</div>
			<ul class="nav nav-tabs" *ngIf="owners.length > 1">
				<li *ngFor="let owner of owners; let i = index" class="nav-item">
					<a data-toggle="tab" href="#owner-{{owner.oForm.firstName.value}}{{i}}"
						[ngClass]="{'active': i == activeTab}" class="nav-link font-mont-regular" id="owner-tab-{{i}}">
						{{owner.getOwnerName(i + 1)}}
						<em class="fa fa-times-circle" *ngIf="owners.length > 1"
							(click)="onRemoveOwnerClick(owner); $event.preventDefault();"></em>
					</a>
				</li>
			</ul>
		</div>

		<div *ngFor="let owner of owners; let i = index" class="tab-pane in" [ngClass]="{'active': i == 0}"
			id="owner-{{owner.oForm.firstName.value}}{{i}}" role="tabpanel"
			attr.aria-labelledby="{{owner.oForm.firstName.value}}-tab">
			<div class="row position-relative" *ngIf="!production">
				<button class="btn btn-primary btn-lg auto-populate"
					(click)="onCompleteInformationClick(owner); $event.preventDefault();">
					<em class="fa fa-check"></em>
				</button>
			</div>
			<form [formGroup]="owner.form" (ngSubmit)="onContinueClick();">
				<div class="owner-info-section clearfix">
					<div class="form-row">
						<div class="form-group col-sm-6">
							<label for="firstName{{i}}"
								[ngClass]="{ 'color-red': submitted && owner.oForm.firstName.errors }">First
								Name*</label>
							<input type="text" formControlName="firstName" class="form-control" id="firstName{{i}}"
								name="firstName"
								[ngClass]="{ 'is-invalid': submitted && owner.oForm.firstName.errors }">
							<div *ngIf="submitted && owner.oForm.firstName.errors" class="invalid-feedback">
								<div *ngIf="owner.oForm.firstName.errors.required">
									First Name is required.
								</div>
							</div>
						</div>
						<div class="form-group col-sm-6">
							<label for="lastName{{i}}"
								[ngClass]="{ 'color-red': submitted && owner.oForm.lastName.errors }">Last Name*</label>
							<input type="text" formControlName="lastName" class="form-control" id="lastName{{i}}"
								name="lastName" [ngClass]="{ 'is-invalid': submitted && owner.oForm.lastName.errors }">
							<div *ngIf="submitted && owner.oForm.lastName.errors" class="invalid-feedback">
								<div *ngIf="owner.oForm.lastName.errors.required">
									Last Name is required.
								</div>
							</div>
						</div>
					</div>
					<div class="form-row">
						<div class="form-group col-sm-6 bsDatepicker">
							<label for="birthDate{{i}}"
								[ngClass]="{ 'color-red': submitted && owner.oForm.birthDate.errors }">Date of
								Birth*</label>
							<input type="text" formControlName="birthDate" class="form-control" id="birthDate{{i}}"
								name="birthDate" [ngClass]="{ 'is-invalid': submitted && owner.oForm.birthDate.errors }"
								bsDatepicker [maxDate]="maxAgeDate"
								[bsConfig]="{ dateInputFormat: 'MM/DD/YYYY', isAnimated: true, containerClass: 'theme-dark-blue' }">
							<div *ngIf="submitted && owner.oForm.birthDate.errors" class="invalid-feedback">
								<div *ngIf="owner.oForm.birthDate.errors.required">
									Birth Date is required.
								</div>
							</div>
						</div>
						<div class="form-group col-sm-6">
							<label for="socialSecurityNumber{{i}}"
								[ngClass]="{ 'color-red': submitted && owner.oForm.socialSecurityNumber.errors }">Social
								Security Number*</label>
							<input type="text" formControlName="socialSecurityNumber" class="form-control"
								id="socialSecurityNumber{{i}}" name="socialSecurityNumber" [showMaskTyped]="true"
								mask="000-00-0000"
								[ngClass]="{ 'is-invalid': submitted && owner.oForm.socialSecurityNumber.errors }">
							<div *ngIf="submitted && owner.oForm.socialSecurityNumber.errors" class="invalid-feedback">
								<div *ngIf="owner.oForm.socialSecurityNumber.errors.required">
									Social Security Number is required.
								</div>
							</div>
						</div>
					</div>
					<div class="form-row">
						<div class="form-group col-sm-6">
							<label for="mobilePhoneNumber{{i}}"
								[ngClass]="{ 'color-red': submitted && owner.oForm.mobilePhoneNumber.errors }">Mobile
								Phone*</label>
							<input type="text" formControlName="mobilePhoneNumber" class="form-control"
								id="mobilePhoneNumber{{i}}" placeholder="Home Phone Number" name="mobilePhoneNumber"
								[showMaskTyped]="true" mask="(000) 000-0000"
								[ngClass]="{ 'is-invalid': submitted && owner.oForm.mobilePhoneNumber.errors }">
							<div *ngIf="submitted && owner.oForm.mobilePhoneNumber.errors" class="invalid-feedback">
								<div *ngIf="owner.oForm.mobilePhoneNumber.errors.required">
									Mobile Phone Number is required.
								</div>
							</div>
						</div>
						<div class="form-group col-sm-6">
							<label for="ownershipPercentage{{i}}"
								[ngClass]="{ 'color-red': submitted && owner.oForm.ownershipPercentage.errors }">Owner
								Percentage*</label>
							<input type="text" formControlName="ownershipPercentage" class="form-control"
								id="ownershipPercentage{{i}}" name="ownershipPercentage"
								[ngClass]="{ 'is-invalid': submitted && owner.oForm.ownershipPercentage.errors }"
								mask="percent" suffix=" %">
							<div *ngIf="submitted && owner.oForm.ownershipPercentage.errors" class="invalid-feedback">
								<div *ngIf="owner.oForm.ownershipPercentage.errors.required">
									Owner Percentage is required.
								</div>
							</div>
						</div>
					</div>
					<div class="form-row" *ngIf="i > 0">
						<div class="form-group col-sm-6">
							<label for="ownerEmail{{i}}" class="font-mont-book"
								[ngClass]="{ 'color-red': submitted && owner.oForm.email.errors }">Email Address:
								*</label>
							<input type="ownerEmail{{i}}" formControlName="email" class="form-control" id="email"
								name="email" [ngClass]="{ 'is-invalid': submitted && owner.oForm.email.errors }">
							<div *ngIf="submitted && owner.oForm.email.errors" class="invalid-feedback">
								<div *ngIf="owner.oForm.email.errors.required">
									Email Address is required.
								</div>
								<div *ngIf="owner.oForm.email.errors.email">
									Invalid email address.
								</div>
							</div>
						</div>
					</div>
					<div class="form-row">
						<div class="form-group col-sm-12">
							<div class="sameAsBusiness-form">
								<input type="checkbox" id="sameAsBusiness" [formControl]="owner.oForm.sameAsBusiness"
									name="sameAsBusiness" (click)="onSetSameBusiness(i)" class="same-as-business">
								<span class="pl-2">Same as Business </span>
							</div>
						</div>
					</div>
					<div class="form-row">
						<div class="form-group col-sm-6">
							<label for="homeAddress{{i}}"
								[ngClass]="{ 'color-red': submitted && owner.oForm.homeAddress.errors }">Home Street
								Address*</label>
							<input type="text" formControlName="homeAddress" class="form-control" id="homeAddress{{i}}"
								name="homeAddress"
								[ngClass]="{ 'is-invalid': submitted && owner.oForm.homeAddress.errors }">
							<div *ngIf="submitted && owner.oForm.homeAddress.errors" class="invalid-feedback">
								<div *ngIf="owner.oForm.homeAddress.errors.required">
									Home Street Address is required.
								</div>
							</div>
						</div>
						<div class="form-group col-sm-6">
							<label for="zipCode{{i}}"
								[ngClass]="{ 'color-red': submitted && owner.oForm.zipCode.errors }">Zip*</label>
							<input type="text" formControlName="zipCode" class="form-control" id="zipCode{{i}}"
								name="zipCode" (keyup)="onZipCodeKeyUpHandler(owner.oForm, i)"
								[ngClass]="{ 'is-invalid': submitted && owner.oForm.zipCode.errors }">
							<div *ngIf="submitted && owner.oForm.zipCode.errors" class="invalid-feedback">
								<div *ngIf="owner.oForm.zipCode.errors.required">
									Zip Code is required.
								</div>
							</div>
						</div>
					</div>
					<div class="form-row">
						<div class="form-group col-sm-6 select">
							<label for="city{{i}}"
								[ngClass]="{ 'color-red': submitted && owner.oForm.city.errors }">City*</label>
							<select formControlName="city" id="city{{i}}" class="form-control"
								[ngClass]="{ 'is-invalid': submitted && owner.oForm.city.errors }">
								<option *ngFor="let city of cities[i]" [ngValue]="city">{{city}}</option>
							</select>
							<div *ngIf="submitted && owner.oForm.city.errors" class="invalid-feedback">
								<div *ngIf="owner.oForm.city.errors.required">
									City is required.
								</div>
							</div>
						</div>
						<div class="form-group col-sm-6 select">
							<label for="state{{i}}"
								[ngClass]="{ 'color-red': submitted && owner.oForm.state.errors }">State*</label>
							<select formControlName="state" id="state{{i}}" class="form-control"
								[ngClass]="{ 'is-invalid': submitted && owner.oForm.state.errors }"
								[attr.disabled]="true">
								<option *ngFor="let state of states" [ngValue]="state.code">{{state.name}}</option>
							</select>
							<div *ngIf="submitted && owner.oForm.state.errors" class="invalid-feedback">
								<div *ngIf="owner.oForm.state.errors.required">
									State is required.
								</div>
							</div>
						</div>
					</div>
				</div>
				<hr>
				<div class="owner-info-section clearfix">
					<div class="form-row">
						<div class="form-group col-sm-12 autorize">
							<div>
								<input type="checkbox" id="creditAuth{{i}}" [formControl]="owner.oForm.creditAuth"
									name="creditAuth{{i}}">
								<div>
									By clicking this box, I authorize ClickLease LLC, and its assigns, on behalf of the
									Applicant, Co-Applicant and any proposed guarantor(s) provided herein (collectively
									the “Authorizing Parties”): (1) to obtain a personal consumer credit report on each
									of the Authorizing Parties, (2) authorize the release to ClickLease LLC of all
									credit and other information ClickLease LLC may request related to the Authorizing
									Parties; and (3) confirm that each of the Authorizing Parties has provided his/her
									Credit Consent.
								</div>
							</div>
							<div>
								<input type="checkbox" id="creditAuthTwo{{i}}" [formControl]="owner.oForm.creditAuthTwo"
									name="creditAuthTwo{{i}}">
								<div>
									By clicking this box, I consent to receiving marketing communications from
									ClickLease at the telephone numbers I provided herein, which may be delivered by
									prerecorded message or autodialed telephone calls or text messages. I understand
									that my consent is not a condition of doing business with, or making purchase of any
									goods/services from, ClickLease. For text messages, message and data rates may
									apply. I understand I may opt-out of any telemarketing calls or text messages at any
									time by communicating my opt-out request during the call, emailing my opt-out
									request to ClickLease at <a href="mailto:CustomerCare@ClickLease.com">
										CustomerCare@ClickLease.com
									</a> with the subject line "Opt out"
									or texting STOP in response to the text message.
								</div>
							</div>
						</div>
					</div>
				</div>
			</form>
		</div>
		<div class="form-row justify-content-between footer-buttons-container">
			<div class="form-group add-co-signer-button-small">
				<button type="submit" class="btn btn-primary w-auto" data-toggle="modal" data-target="#coSignerModal"
					(click)="addCosigner()">
					ADD Co-Signer
				</button>
			</div>
		</div>
		<div class="form-row justify-content-between footer-buttons-container">
			<div class="form-group">
				<button type="submit" class="btn btn-secondary btn-lg col-md-12" (click)="onBackClick();">BACK</button>
			</div>
			<div class="form-group add-co-signer-button-big">
				<button type="submit" class="btn btn-primary w-auto" data-toggle="modal" data-target="#coSignerModal"
					(click)="addCosigner()">
					ADD Co-Signer
				</button>
			</div>
			<div class="form-group">
				<button type="submit" class="btn btn-primary btn-lg col-md-12" data-toggle="modal"
					(click)="showVerifyInformationModal()" [disabled]="buttonContinueDisabled">
					NEXT
				</button>
			</div>
		</div>
	</div>
	<app-what-makes-us-different></app-what-makes-us-different>
	<app-error-dialog [modalId]="errorId" [title]="errorTitle" [messageA]="errorMessageA" [messageB]="errorMessageB"
		[messageC]="errorMessageC" [messageBClass]="errorMessageBClass" [dialogClass]="'w600'">
	</app-error-dialog>
</div>
<app-co-signer-information [statesIssued]="statesIssued" [ownershipPercentage]="ownershipPercentage"
	(ownerItem)="getOwnerItem($event)" [appInfo]="appInfo" [token]="token">
</app-co-signer-information>

<app-verify-information [$appInfo]="appInfo" [$ownersInfo]="owners[0]" [statesIssued]="statesIssued" [token]="token"
	[owners]="owners" (submitClicked)="onContinueClick($event)" (backClicked)="onBackClick()"></app-verify-information>